// apps/client/src/components/XeroSyncEmployees.tsx

import React from 'react';
import { XeroSyncEmployeesResponse, XeroSyncType } from '@avanzu/types';
import { XeroSyncButton } from './XeroSyncButton';

interface XeroSyncEmployeesProps {
  onSyncComplete?: (result: XeroSyncEmployeesResponse) => void;
  variant?: 'contained' | 'outlined' | 'text';
  size?: 'small' | 'medium' | 'large';
  fullWidth?: boolean;
  disabled?: boolean;
}

const XeroSyncEmployees: React.FC<XeroSyncEmployeesProps> = (props) => {
  return (
    <XeroSyncButton<XeroSyncEmployeesResponse>
      syncType={XeroSyncType.EMPLOYEES}
      pollInterval={250}
      {...props}
    />
  );
};

export default XeroSyncEmployees;
